import React from 'react'

export const Figma = ({ size = 24, className, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_529_4837)">
        <path
          d="M6.00086 13.9998C7.10453 13.9998 8.00027 13.1039 8.00027 12V10.0002H6.00086C4.8972 10.0002 4.00146 10.8962 4.00146 12C4.00146 13.1039 4.8972 13.9998 6.00086 13.9998Z"
          fill="#0ACF83"
        />
        <path
          d="M4.00146 8.00029C4.00146 6.8964 4.8972 6.00049 6.00086 6.00049H8.00027V10.0001H6.00086C4.8972 10.0001 4.00146 9.10418 4.00146 8.00029Z"
          fill="#A259FF"
        />
        <path
          d="M4.00146 4.00102C4.00146 2.89713 4.8972 2.00122 6.00086 2.00122H8.00027V6.00082H6.00086C4.8972 6.00082 4.00146 5.10491 4.00146 4.00102Z"
          fill="#F24E1E"
        />
        <path
          d="M8 2.00122H9.9994C11.1031 2.00122 11.9988 2.89713 11.9988 4.00102C11.9988 5.10491 11.1031 6.00082 9.9994 6.00082H8V2.00122Z"
          fill="#FF7262"
        />
        <path
          d="M11.9988 8.00029C11.9988 9.10418 11.1031 10.0001 9.9994 10.0001C8.89573 10.0001 8 9.10418 8 8.00029C8 6.8964 8.89573 6.00049 9.9994 6.00049C11.1031 6.00049 11.9988 6.8964 11.9988 8.00029Z"
          fill="#1ABCFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_529_4837">
          <rect
            width="8"
            height="11.9976"
            fill="white"
            transform="translate(4 2.00122)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
